export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'label', label: 'Title', sortable: true },
    { key: 'key', label: 'Key', sortable: true },
    { key: 'value', label: 'Value', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
